import { HttpErrorResponse } from '@angular/common/http';
import { concat, Observable, of, throwError, timer } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { AcceptedError } from './acceptedError';

export function handleError(
  error: HttpErrorResponse,
  caught: Observable<unknown>,
  returnAcceptedError = true,
) {
  // This is a merger of an example error handler from Angular
  // (https://angular.io/guide/http#handling-request-errors) together with some code to handle our
  // custom "errors" for when HTTP 202 code is returned.
  if (error instanceof AcceptedError) {
    // Return a new Observable which starts with the AcceptedError (notifying any caller that there was
    // a 202 received) and then retry after that.
    if (returnAcceptedError) {
      return concat(
        of(error),
        timer((error as AcceptedError).retryDelay).pipe(mergeMap(() => caught)),
      );
    } else {
      return concat(
        timer((error as AcceptedError).retryDelay).pipe(mergeMap(() => caught)),
      );
    }
  } else if (error.error instanceof ErrorEvent) {
    // A client-side or network error occurred. Handle it accordingly.
    console.error('An error occurred:', error.error.message);
  } else {
    // The backend returned an unsuccessful response code.
    // The response body may contain clues as to what went wrong,
    console.error(
      `Backend returned code ${error.status}, ` + `body was: ${error.error}`,
    );
  }

  // return an observable with a user-facing error message
  return throwError('Something bad happened; please try again later.');
}
